// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import * as Sentry from '@sentry/react';
import { dropErrorOutsideOwnBundle } from '../../../reactSrc/utils/sentryBeforeSend';

/**
 * Sentryを初期化する
 * ブラウザ環境で実行され、Reactアプリケーションのすべてのエラーをキャッチする
 */
const sentryDsn = process.env.SENTRY_DSN;

if (sentryDsn) {
  const environment = process.env.ENVIRONMENT;

  Sentry.init({
    dsn: sentryDsn,
    environment: environment || 'staging',
    // リリースバージョン（webpackと同じバージョンを使用してソースマップを関連付ける）
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({ maskAllText: true, blockAllMedia: true }),
    ],
    // パフォーマンス監視のサンプリングレート (0.0 から 1.0)
    tracesSampleRate: environment === 'production' ? 0.1 : 1.0,
    // セッションリプレイのサンプリングレート
    replaysSessionSampleRate: 0.1,
    // エラー時のセッションリプレイのサンプリングレート
    replaysOnErrorSampleRate: 1.0,
    beforeSend: dropErrorOutsideOwnBundle,
  });
}

import Rails from '@rails/ujs';
import Turbolinks from 'turbolinks';

require('jquery');

import 'bootstrap';
import '../stylesheets/application.scss';
import './desired_date';
import '../../../reactSrc/index';
import '../events/index';

import '@fortawesome/fontawesome-free/js/all';
require.context('../images', true);

// このパックが同一ページで2回評価されることがあり、2回目の Rails.start() が
// 「rails-ujs has already been loaded!」で throw していた。起動処理は最初の1回だけ行う。
// window._rails_loaded は rails-ujs が起動済みかどうかを持つフラグで、webpack のモジュール
// レジストリをまたいで残る。
if (!window._rails_loaded) {
  Rails.start();
  Turbolinks.start();
}
